<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-20 16:20:53
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-07 09:37:58
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/attachmentInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 产品质量评价委托协议 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <eui-btn
          type="link"
          @click="
            downLoadAgreement(
              applyInfo.evaluationApplyCommissionAttachmentVO.agreementPath
            )
          "
          >{{
            applyInfo.evaluationApplyCommissionAttachmentVO.agreementName
          }}</eui-btn
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '../../../../api/evaluation/index';

export default {
  props: {
    applyInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},
  methods: {
    async downLoadAgreement(url) {
      let res = await api.getOssPath({ ossPrivateFilePath: url });
      if (res.code === '200') {
        window.open(res.data);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
